<span class="text--small text--bold label">
  {{ 'feed-profit.detail.baseline-table.' + feederType | translate }}
</span>
<agr-table
  [config]="tableConfig"
  [attr.data-test]="'baseline-table__' + feederType"
  [enableStepArrows]="false"
>
</agr-table>
<ng-template #productNameTemplate let-row="row">
  <mat-select
    [hideSingleSelectionIndicator]="true"
    class="flex__child--auto spacing--margin-right text--small"
    panelClass="mat-select-product-panel"
    [value]="getProduct(row, products)"
    [compareWith]="areProductsEqual"
    placeholder="< product >"
    (selectionChange)="selectProduct($event, row)"
    data-test="product-column"
    [ngClass]="productError && !getProduct(row, products) ? 'validation-error' : ''"
  >
    <mat-option *ngFor="let product of products" [value]="product">
      {{ product.code }} - {{ product.name }}
    </mat-option>
  </mat-select>
</ng-template>
<ng-template #deleteIconTemplate let-row="row">
  <ng-container *ngIf="feederType === endFeederType && tableConfig.dataSource.data.length === 1">
    <mat-icon [ngStyle]="{ cursor: 'pointer' }" (click)="clearTableRow(row)"> delete </mat-icon>
  </ng-container>
  <ng-container *ngIf="tableConfig.dataSource.data.length > 1">
    <mat-icon [ngStyle]="{ cursor: 'pointer' }" (click)="deleteTableRow(row)"> delete </mat-icon>
  </ng-container>
</ng-template>

<app-baseline-calculated-table
  *ngIf="feederType === endFeederType"
  [calculatedEndFeederRows]="calculatedEndFeederRows"
  [products]="baselineFeedersComponent.products$ | async"
  [discounts]="baselineFeedersComponent.discounts$ | async"
  [isExtendedSimulation]="isExtendedSimulation"
  (calculatedFeederPropertiesChanged)="calculatedFeederPropertiesChangedPropegation($event)"
></app-baseline-calculated-table>

<div class="mat-button-row wrapper--spacing-vertical">
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    [attr.data-test]="'baseline-table__' + feederType + '__add-product-button'"
    (click)="addProduct()"
  >
    <mat-icon>add</mat-icon>{{ 'feed-profit.detail.baseline-table.add-product' | translate }}
  </button>
</div>
